import { http } from "../api/http";
import Utils from "../utils";

/**
 * Drops null/undefined before serializing.
 *
 * Utils.objectToQueryString keeps undefined values and encodes them as the literal
 * string "undefined" (encodeURIComponent(undefined) === "undefined", which passes its
 * truthiness filter). On these endpoints that matters: a SuperUser sending
 * clientId=undefined would have it honoured as a requested client id and get back an
 * "Unknown" client rather than falling back to their own scope.
 */
const toQueryString = (params = {}) =>
  Utils.objectToQueryString(
    Object.fromEntries(Object.entries(params).filter(([, value]) => value !== null && value !== undefined))
  );

export const usageService = {
  getClientUsage,
  getPortfolioSummary,
  getClientRows,
  // Tier configuration
  getTiers,
  createTier,
  updateTier,
  deleteTier,
  getClientTiers,
  assignClientTier,
  removeClientTier,
};

async function getClientUsage(requestParameters) {
  const url = `/usage-analytics/client?${toQueryString(requestParameters)}`;
  const response = await http.get(url);
  return response;
}

async function getPortfolioSummary(requestParameters) {
  const url = `/usage-analytics/summary?${toQueryString(requestParameters)}`;
  const response = await http.get(url);
  return response;
}

async function getClientRows(requestParameters) {
  const url = `/usage-analytics/clients?${toQueryString(requestParameters)}`;
  const response = await http.get(url);
  return response;
}

async function getTiers(includeInactive = false) {
  const url = `/usage-analytics/tiers?${toQueryString({ includeInactive })}`;
  const response = await http.get(url);
  return response;
}

async function createTier(tier) {
  const response = await http.post(`/usage-analytics/tiers`, tier);
  return response;
}

async function updateTier(tier) {
  const response = await http.patch(`/usage-analytics/tiers`, tier);
  return response;
}

async function deleteTier(tierId) {
  const response = await http.delete(`/usage-analytics/tiers?${toQueryString({ tierId })}`);
  return response;
}

async function getClientTiers() {
  const response = await http.get(`/usage-analytics/client-tiers`);
  return response;
}

async function assignClientTier(assignment) {
  const response = await http.put(`/usage-analytics/client-tier`, assignment);
  return response;
}

async function removeClientTier(clientId) {
  const response = await http.delete(`/usage-analytics/client-tier?${toQueryString({ clientId })}`);
  return response;
}
